<li class="nav-item" ngbDropdown>
  <a class="nav-link text-nowrap" [id]="'nav-item' + props.text" ngbDropdownToggle>
    <i class="now-ui-icons {{props.icon}}"></i>
    <p>{{props.text | translate}} </p>
  </a>
  <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu [attr.aria-labelledby]="'nav-item' + props.text">
    @for (dropOption of props.children; track dropOption) {
      <a class="dropdown-item" [routerLink]="mainUrl(dropOption.route)" [queryParams]="queryUrl(dropOption.route)">{{dropOption.text | translate}}</a>
    }
  </div>
</li>
